import {
  select, put, call,
} from 'redux-saga/effects';
import { cancelCQ as cancelCQBit } from '../bitSagas/cancelCQ';
import { actions as loaderControlActions } from '../reducers/loaderControl';
import { commonActions } from '../reducers/common';
import { USER_TYPE } from '../bitConstants/constants';
import { STRING_KEYS } from '../localizedStrings';
import { deleteShopper } from '../bitSagas/deleteShopper';

const contextStore = state => state.context.data;
const flowStore = state => state.flow;
const localizedStringsStore = state => state.localizedStrings;
const apiNeedsStore = state => state.apiNeeds;

export function* resetFlow(params) { // TODO DELETE DEAD CODE
  const { localizedStrings } = yield select(localizedStringsStore);
  yield put(
    loaderControlActions.setLoaderState({
      loading: true,
      loadingText: localizedStrings[STRING_KEYS.waitingPageTexts.resetFlow],
    }),
  );
  const { showError, normalizeHttpErrors, payload } = params;
  const { isPersonalDataStep } = payload;
  const reduxUpdate = {
    errorUpdate: showError,
  };
  const context = yield select(contextStore);

  if (isPersonalDataStep && context.userType === USER_TYPE.OPEN) {
    try {
      const deleteShopperParams = {
        reduxUpdate,
        normalizeHttpErrors,
      };
      yield call(deleteShopper, deleteShopperParams);
    } catch (e) {
      console.log(e);
    }
    const { flowJson, searchParams } = yield select(flowStore);
    const { flowName } = flowJson;

    window.location.href = `${localizedStrings[STRING_KEYS.clientRegister.url]}${searchParams}&buyProcess=${flowName}`;
  } else {
    const { cqId } = yield select(apiNeedsStore);
    const cancelCQParams = {
      reduxUpdate,
      normalizeHttpErrors,
      cqId,
    };

    try {
      yield call(cancelCQBit, cancelCQParams);
    } catch (e) {
      console.log(e);
    }
    yield put(commonActions.resetFlow());
  }

  yield put(loaderControlActions.setLoaderState({ loading: false }));
}
